import React, { useContext } from 'react'
import { Table } from 'components/common'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { UserContext } from "../../stores/UserStore"
import { FaArrowRight } from 'react-icons/fa'
import { TubularContext } from 'stores/TubularStore'
import moment from 'moment'
import styled from 'styled-components'

const DetailArrow = styled(FaArrowRight)`
  color: #777;
  cursor: pointer;
  transition: 0.5s;
   
   &:hover{
    color: #aaa;
   }
`
const InvoiceCard = ({ data }) => {
    const history = useHistory()
    const { registryLogOld, registryLog } = useContext(UserContext)
    const { setValueData } = useContext(TubularContext)

    const goTo = (value) => {
        registryLogOld('got_to_invoice', '/tlh/home')
        registryLog('home', 'navigation', 'got_to_invoice')
        setValueData(value)
        history.push("/invoice/" + value)
    }

    const { t } = useTranslation()

    const columns = [
        {
            Header: t('tlh.home.tabs.invoice').toUpperCase(),
            accessor: (row) => row.invoice,
            id: 'invoice',
        },
        {
            Header: t("tlh.search.origin"),
            accessor: (row) => row.origin,
            id: 'origin',
        },
        {
            Header: t("tlh.search.destination"),
            accessor: (row) => row.destination,
            id: 'destination',
        },
        {
            Header: t("tlh.search.customer"),
            accessor: (row) => row.customerId,
            id: 'contract',
        },
        {
            Header: t("tlh.search.keyAccess"),
            accessor: (row) => row.access,
            id: 'acess',
        },
        {
            Header: t('tlh.search.date'),
            accessor: (row) => moment(row.date).format("DD/MM/YYYY"),
            id: 'date',
        },
        {
            Header: 'See piece',
            accessor: (row) => {
                return (
                    <DetailArrow size="1rem" onClick={() => { goTo(row.invoice) }} />
                )
            },
        }
    ]

    return (
        <Table width="100%" columns={columns} data={data} sortable paginated style={{ whiteSpace: 'nowrap' }} ></Table>
    )
}

export default InvoiceCard
